import React from 'react';
import './AboutSection.css';
import { MdVerifiedUser } from "react-icons/md";
import { 
  mentorRaghav, 
  mentorDanis, 
  mentorRevanth, 
  mentorSanjay 
} from '../../assets/images';

const AboutSection = () => {
  return (
    <section className="about-section" id="about">
      <div className="about-container">
        <div className="teachers-container">
          <div className="teachers-card">
            <h3 className="teachers-title">100+ Verified <br/> Teachers</h3>
            
            <ul className="teachers-list">
              <li className="teacher-card">
                <img src={mentorDanis} alt="Danis" className="teacher-avatar" />
                <div className="teacher-info">
                  <h4>Danis</h4>
                  <p>AWS Mentor</p>
                </div>
              </li>
              <li className="teacher-card">
                <img src={mentorRevanth} alt="Revanth" className="teacher-avatar" />
                <div className="teacher-info">
                  <h4>Revanth</h4>
                  <p>AWS Mentor</p>
                </div>
              </li>
              <li className="teacher-card">
                <img src={mentorSanjay} alt="Sanjay" className="teacher-avatar" />
                <div className="teacher-info">
                  <h4>Sanjay</h4>
                  <p>AWS Mentor</p>
                </div>
              </li>
            </ul>
          </div>
          
          <div className="verification-icon" aria-hidden="true">
            <MdVerifiedUser size={30} color="#ffffff" />
          </div>
          
          <div className="featured-teacher-card">
            <div className="featured-teacher-content">
              <img src={mentorRaghav} alt="Raghavender Kulkarni" className="featured-teacher-image" />
              <h2>Raghavender <br/> Kulkarni</h2>
              <p className="teacher-bio">
                having 16 years of IT experience and 10 years of Training experience, Taught 8500+ students. Working As a Manager (Cloud and DevOps)
              </p>
            </div>
          </div>
        </div>
        
        <div className="about-text">
          <h2 className="section-title">Who are we</h2>
          <div className="title-underline"></div>
          <p className="about-description">
            At SkillRaiz, we specialize in helping professionals and students develop in-demand AWS skills. Our mission is to empower individuals with cloud computing knowledge to thrive in today's tech-driven world.
          </p>
          <p className="about-description">
            With a focus on practical learning and mentorship, we guide you step-by-step on your AWS journey.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutSection; 